module.exports = __webpack_public_path__ + "static/media/background-login.dc3c5f72.jpg";